import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';
import { WORK_ORDER_LABELS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/work_order_labels_actions';

const initialState: any = standardInitialStateGenerator([
	// Shared catalogue read by the Edit Labels drawer and the Work Orders
	// "Labels" advanced filter.
	'workOrderLabelsIndex',
	'workOrdersAdvancedFilters',
	// Private to the Add Label modal's searchable/paginated dropdown — kept
	// separate so its server-side search + paging never clobbers the shared
	// catalogue the advanced filter renders on the same screen.
	'workOrderLabelsDropdown',
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
